<template>
  <div id="content" class="container">
    <div class="row">
      <div class="col-12">
        <a
          class="back"
          @click="this.$router.push({ path: this.$store.state.search_back })"
          >Retour</a
        >
        <h1>Contacts</h1>
      </div>
    </div>
    <div class="row cards">
      <div class="col-12 col-md-6 col-xl-4">
        <div class="content_card">
          <h2>Capitol, Polydor, Vinyl Collector</h2>
          <div class="contact_items">
            <ContactItem :contact="this.contacts[3]"></ContactItem>
            <ContactItem :contact="this.contacts[0]"></ContactItem>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 col-xl-4">
        <div class="content_card">
          <h2>
            Panthéon, Decca, Barclay, Phonogram, Virgin, Everything Jazz, Aura
          </h2>
          <div class="contact_items">
            <ContactItem :contact="this.contacts[1]"></ContactItem>
            <ContactItem :contact="this.contacts[5]"></ContactItem>
          </div>
        </div>
      </div>
      <div class="col-12 offset-md-4 col-md-4 offset-xl-0 col-xl-3 claire">
        <div class="content_card">
          <div class="contact_items">
            <ContactItem :contact="this.contacts[4]"></ContactItem>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactItem from "@/components/ContactItem.vue";

export default {
  name: "Contact",
  data() {
    return {
      contacts: [
        {
          img: "mgervais.jpg",
          name: "Mathilde Gervais",
          poste: "Assistant Chef de projet CRM",
          email: "mathilde.gervais@umusic.com",
        },
        {
          img: "marina.jpg",
          name: "Marina Wong",
          poste: "Cheffe de projet CRM",
          email: "marina.wong@umusic.com",
        },
        {
          img: "cloe.jpg",
          name: "Cloé Florville",
          poste: "Cheffe de projet CRM",
          email: "cloe.florville@umusic.com",
        },
        {
          img: "eva.jpg",
          name: "Eva Marcelat",
          poste: "Cheffe de projet CRM",
          email: "eva.marcelat@umusic.com",
        },
        {
          img: "claire.jpg",
          name: "Claire Cavallini",
          poste: "Directrice Data & Développement",
          email: "claire.cavallini@umusic.com",
        },
        {
          img: "soum.jpg",
          name: "Sereydanida Oum",
          poste: "Assistant Chef de projet CRM",
          email: "sereydanida.oum@umusic.com",
        },
      ],
      activists: [],
    };
  },
  components: {
    ContactItem,
  },
  mounted() {
    this.$store.state.app_id = "contact";
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.state.search_back = from.fullPath;
    });
  },
};
</script>

<style lang="scss">
#contact {
  #content {
    padding-top: 180px;

    & > div:first-child {
      background: url("../assets/img/contact-background.svg") no-repeat bottom
        right;
    }
  }

  h1 {
    font-weight: 900;
    line-height: 103%;
    color: $blue-umf;
    margin-bottom: 40px;
  }

  .cards {
    .content_card {
      //display: inline-block;
      background-color: #eeeded;
      margin-bottom: 16px;
      padding: 20px;
      border-radius: 30px;

      h2 {
        display: block;
        font-size: 2rem;
        font-weight: 700;
        color: $blue-umf;
        margin-bottom: 15px;
      }
    }

    .claire {
      .contact_card {
        width: 100%;
      }
    }
  }

  .activists {
    background-color: #ededed;
    color: $blue-umf;
    padding: 33px;

    h2 {
      margin-bottom: 20px;
    }

    .activists-content {
      background-color: #ffffff;
      border-radius: 30px;
      padding: 26px 32px;
      font-weight: 400;
      font-size: 1.5rem;
      line-height: 133%;

      .activist {
        margin-bottom: 10px;
      }

      a {
        font-weight: 500;
        font-size: 1.7rem;
        color: $blue-umf;
        line-height: 140%;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

@include media-breakpoint-down(lg) {
  #contact {
    #content {
      & > div:first-child {
        background-size: contain;
        margin-bottom: 20px;
      }
    }
  }
}

@include media-breakpoint-down(md) {
  #contact {
    .contact_card {
      display: flex;

      .img {
        width: 96px;
        height: auto;
      }
    }
  }
}

@include media-breakpoint-up(md) {
  #contact {
    .contact_card {
      .infos {
        //height: calc(100% - 230px);
      }
    }

    .activists {
      border-radius: 30px;
      padding: 50px;

      .activists-content {
        padding: 38px 78px;
      }
    }
  }
}

@include media-breakpoint-up(lg) {
  #contact {
    #content {
      & > div:first-child {
        padding-bottom: 40px;
      }
    }

    .contact_items {
      display: flex;
    }

    h1 {
      margin-bottom: 100px;
    }

    .cards {
      position: relative;
      top: -20px;
      h2 {
        min-height: 3lh;
      }
    }
  }
}

@include media-breakpoint-up(xl) {
  #contact {
    .claire .contact_card {
      padding-top: 85px;
    }
  }
}
</style>
